import { render, staticRenderFns } from "./StatementRow.vue?vue&type=template&id=74283af3&scoped=true"
import script from "./StatementRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatementRow.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./StatementRow.vue?vue&type=style&index=0&id=74283af3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74283af3",
  null
  
)

export default component.exports